import {
  START_LOADING,
  END_LOADING,
  FETCH_ATTRIBUTES,
  FETCH_ATTRIBUTE,
  CREATE_ATTRIBUTE,
  UPDATE_ATTRIBUTE,
  DELETE_ATTRIBUTE,
  FETCH_ATTRIBUTE_VALUES,
  CREATE_ATTRIBUTE_VALUE,
  UPDATE_ATTRIBUTE_VALUE,
  DELETE_ATTRIBUTE_VALUE
} from '../actions/constants';

const initialState = {
  attributes: [],
  attribute: null,
  attributeValues: {},
  isLoading: false,
  numberOfPages: 1,
  currentPage: 1
};

const attributeReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true };
    
    case END_LOADING:
      return { ...state, isLoading: false };
    
    case FETCH_ATTRIBUTES:
      return {
        ...state,
        attributes: action.payload.attributes,
        numberOfPages: action.payload.numberOfPages,
        currentPage: action.payload.currentPage
      };
    
    case FETCH_ATTRIBUTE:
      return { ...state, attribute: action.payload };
    
    case CREATE_ATTRIBUTE:
      return { 
        ...state, 
        attributes: [...state.attributes, action.payload]
      };
    
    case UPDATE_ATTRIBUTE:
      return { 
        ...state, 
        attributes: state.attributes.map((attribute) => 
          attribute._id === action.payload._id ? action.payload : attribute
        ),
        attribute: state.attribute?._id === action.payload._id ? action.payload : state.attribute
      };
    
    case DELETE_ATTRIBUTE:
      return { 
        ...state, 
        attributes: state.attributes.filter((attribute) => attribute._id !== action.payload),
        attribute: state.attribute?._id === action.payload ? null : state.attribute,
        attributeValues: {
          ...state.attributeValues,
          [action.payload]: undefined
        }
      };
    
    case FETCH_ATTRIBUTE_VALUES:
      return { 
        ...state, 
        attributeValues: {
          ...state.attributeValues,
          [action.payload.attributeId]: action.payload.values
        }
      };
    
    case CREATE_ATTRIBUTE_VALUE:
      return { 
        ...state, 
        attributeValues: {
          ...state.attributeValues,
          [action.payload.attributeId]: [
            ...(state.attributeValues[action.payload.attributeId] || []),
            action.payload.value
          ]
        }
      };
    
    case UPDATE_ATTRIBUTE_VALUE:
      return { 
        ...state, 
        attributeValues: {
          ...state.attributeValues,
          [action.payload.attributeId]: (state.attributeValues[action.payload.attributeId] || []).map(
            (value) => value._id === action.payload.valueId ? action.payload.value : value
          )
        }
      };
    
    case DELETE_ATTRIBUTE_VALUE:
      return { 
        ...state, 
        attributeValues: {
          ...state.attributeValues,
          [action.payload.attributeId]: (state.attributeValues[action.payload.attributeId] || []).filter(
            (value) => value._id !== action.payload.valueId
          )
        }
      };
    
    default:
      return state;
  }
};

export default attributeReducer;
